import { render } from "./TagInputContent.vue?vue&type=template&id=3cfa2974"
import script from "./TagInputContent.vue?vue&type=script&lang=ts"
export * from "./TagInputContent.vue?vue&type=script&lang=ts"

import "./TagInputContent.vue?vue&type=style&index=0&id=3cfa2974&lang=scss"
script.render = render

export default script
import QInput from 'quasar/src/components/input/QInput.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QTooltip,QField});
